import React, { useRef, useState } from 'react';
const DraggableElement = _ref => {
  let {
    parentElementType = 'tr',
    element,
    onDragStart = () => {},
    onDrop,
    draggedElement,
    setDraggedElement,
    setCurrentAction,
    children,
    dragOverClassName = 'isDraggingOver',
    userCanDrag = true
  } = _ref;
  const [isDraggingOver, setIsDraggingOver] = useState(false);
  const dragStart = e => {
    onDragStart(element);
  };
  const drop = e => {
    e.preventDefault();
    onDrop(draggedElement, element);
    setIsDraggingOver(false);
    setCurrentAction(null);
  };
  const dragOver = e => {
    e.preventDefault();
    const isDraggedElementFile = draggedElement.hasOwnProperty('download_link');
    const isDroppedElementFile = element.hasOwnProperty('download_link');
    const draggedFileIsOverItsOwnFolder = isDraggedElementFile && draggedElement.folder_id === element.id;
    if (!draggedElement.name || isDroppedElementFile || draggedElement.id === element.id || draggedFileIsOverItsOwnFolder || !isDraggedElementFile && draggedElement.parent_folder_id === element.id || draggedElement.virtual_folder) {
      return;
    }
    setCurrentAction("".concat(draggedElement.name, " >> ").concat(element.name));
    setIsDraggingOver(true);
  };
  const dragLeave = e => {
    e.preventDefault();
    setCurrentAction(null);
    setIsDraggingOver(false);
  };
  const dragDropElement = /*#__PURE__*/React.createElement(parentElementType, {
    draggable: userCanDrag,
    onDragStart: userCanDrag ? dragStart : () => {},
    onDrop: userCanDrag ? drop : () => {},
    onDragOver: userCanDrag ? dragOver : () => {},
    onDragLeave: userCanDrag ? dragLeave : () => {},
    className: userCanDrag && isDraggingOver ? dragOverClassName : ''
  }, children);
  return dragDropElement;
};
export default DraggableElement;